/**
 * Права текущего пользователя (контракты §3, §5). Список прав приходит с сервера
 * в ответе сессии; интерфейс по нему строит меню и маршруты, но backend проверяет
 * права независимо, и скрытая кнопка не заменяет серверный запрет.
 */

import { PERMISSIONS, type Permission } from '@/api/workspaceTypes';

const KNOWN: ReadonlySet<string> = new Set(PERMISSIONS);

/** Есть ли право в списке; без списка — нет */
export function hasPermission(
	capabilities: readonly Permission[] | null | undefined,
	permission: Permission,
): boolean {
	return capabilities?.includes(permission) ?? false;
}

/** Список прав из ответа сервера: известные значения, остальное отбрасывается */
export function normalizeCapabilities(raw: unknown): Permission[] {
	if (!Array.isArray(raw)) {
		return [];
	}
	return raw.filter((value): value is Permission => typeof value === 'string' && KNOWN.has(value));
}
